import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'DivWithChildren',
	loadComponent: () => import('./DivWithChildren.js' /* webpackChunkName: "DivWithChildren" */),
}

export default entry
